var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"flat":"","app":"","color":"purple lighten-1 white--text"}},[_c('v-toolbar-title',{staticClass:"white--text",attrs:{"router:to":"/"}},[_vm._v("株式会社happiness")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }